export class JobTitle {
    /** @type {string} */
    _id = '';

    /** @type {string} */
    name = '';

    /** @type {string} */
    subName = '';

    /** @type {string} */
    company = '';

    /** @type {string} */
    createdAt = '';

    /** @type {string} */
    updatedAt = '';

    /**
     * @param {Object} obj
     * @returns {JobTitle}
     */
    static fromArray(obj) {
        return Object.assign(new this, obj || {});
    }
}